import { DetailsInterface } from '@/core/domain/details/models/details.model';
import {
    getDetailsUseCase,
    ReservationDetailsRequest,
} from '@/core/domain/details/usecases/getDetails.usecase';
import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    catchError,
    Observable,
    take,
    tap,
    throwError,
} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReservationDataService {
    private detailsSubject = new BehaviorSubject<DetailsInterface | null>(null);
    details$: Observable<DetailsInterface | null> =
        this.detailsSubject.asObservable();

    constructor(private getDetailsUseCase: getDetailsUseCase) {}

    fetchDetails(
        reservationDetails: ReservationDetailsRequest,
    ): Observable<DetailsInterface> {
        return this.getDetailsUseCase.execute(reservationDetails).pipe(
            catchError((error) => {
                this.detailsSubject.error(error);
                return throwError(() => error);
            }),
            take(1),
            tap((details) => {
                this.detailsSubject.next(details);
            }),
        );
    }

    getDetails(): Observable<DetailsInterface | null> {
        return this.details$;
    }

    clearDetailsCache(): void {
        this.detailsSubject.next(null);
    }
}
